export default __webpack_public_path__ + "static/media/Ch4a.a31bd0fe.gif";